module.exports = __webpack_public_path__ + "static/media/IconFace.70d4bfc0.svg";